import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface UserCircleIconProps {
  className?: string;
}

export const UserCircleIcon = ({ className = '' }: UserCircleIconProps) => {
  return <FontAwesomeIcon icon={faUserCircle} className={className} />;
};
